
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/[skuBase]/[[...skuVariant]]",
      function () {
        return require("private-next-pages/preview/[skuBase]/[[...skuVariant]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/[skuBase]/[[...skuVariant]]"])
      });
    }
  